import { render, staticRenderFns } from "./igt-tabs.vue?vue&type=template&id=6b4f20d2&scoped=true&"
import script from "./igt-tabs.vue?vue&type=script&lang=js&"
export * from "./igt-tabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4f20d2",
  null
  
)

export default component.exports